import {Button, ButtonGroup, DialogBody, DialogFooter, Separator, Stack, Text, Textarea} from "@chakra-ui/react";
import {Form, UI} from "components";
import {toaster} from "config";
import {API} from "config";
import useOrder from "hooks/useOrder";
import {useState} from "react";

export default function Cancel({data = {}, ...props}) {

    const order = useOrder(data?.id)
    const [loading, setLoading] = useState(false)
    const [canceled_reason, setCanceledReason] = useState('')

    const handleCancel = async () => {
        if (!window.confirm('Tem certeza que deseja cancelar este pedido?')) return
        setLoading(true)

        try {
            await API.put(`/orders/${order?.data?.id}/cancel_distributors`, {
                canceled_reason,
            })
            toaster.create({title: 'O pedido foi cancelado', type: 'info'})
            await order.refetch()
            props.onClose()
        } catch (err) {
            toaster.create({
                title: 'Não foi possível cancelar o pedido',
                description: err?.response?.data?.message,
                type: 'warning'
            })
        }

        setLoading(false)
    }

    return (
        <UI.Dialog loading={loading} size="sm" title={`Cancelar pedido #${order.data?.cod}?`} {...props}>

            <DialogBody fontSize="sm">
                <UI.Alert status="warning" title="Você está cancelando um pedido de núcleo" mb={5}>
                    Você está prestes a cancelar um pedido. Esta ação é definitiva e irreversível. Tenha em mente os
                    efeitos colaterais ao realizar
                    o cancelamento de um pedido:
                </UI.Alert>

                <Text fontWeight="bold">O que acontece ao cancelar um pedido?</Text>

                <ul>
                    <li>
                        <Text mb={5}>Pagamentos realizados com bônus serão retornados.</Text>
                    </li>
                    <li>
                        <Text mb={5}>Produtos reservados no estoque ficarão disponíveis novamente.</Text>
                    </li>
                </ul>

                <Form.Text
                    size="sm"
                    label="Motivo do cancelamento:"
                    placeholder="Ex.: O pedido foi cancelado por..."
                    helper="O motivo do cancelamento é obrigatório e deve ser detalhado."
                    value={canceled_reason}
                    onChange={e => setCanceledReason(e.target.value)}
                    isDisabled={loading}
                />
            </DialogBody>

            <DialogFooter>
                <ButtonGroup>
                    <Button loading={loading} loadingText="Cancelando pedido..." variant="subtle" colorPalette="red"
                            disabled={loading || !canceled_reason?.trim()}
                            onClick={handleCancel}>
                        <UI.Icon name="cancel"/> Cancelar pedido
                    </Button>
                    <Button disabled={loading} variant="ghost" onClick={props.onClose}>Fechar</Button>
                </ButtonGroup>
            </DialogFooter>

        </UI.Dialog>
    )
}